import { AbstractControl, FormControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { equalTo } from './validator';

@Directive({
    selector: '[equalTo][formControlName],[equalTo][formControl],[equalTo][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EqualToValidatorDirective),
            multi: true,
        },
    ],
})
export class EqualToValidatorDirective implements Validator, OnChanges, OnInit {
    private validator: ValidatorFn;

    @Input()
    equalTo: FormControl;

    ngOnInit() {
        this.validator = equalTo(this.equalTo);
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('equalTo' in changes) {
            this.validator = equalTo(this.equalTo);
        }
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
